const additional_attributes_dict = {
  bank_details:
    [
      { name: 'Name for Payment', type: 'STRING', is_required: true },
      { name: 'Account Number', type: 'STRING', is_required: true },
      { name: 'Bank Name', type: 'STRING', is_required: true },
      { name: 'IFSC Code', type: 'STRING', is_required: true },
      { name: 'cheque number', type: 'STRING', is_required: true }
    ]
  ,
  contact_details: [
    { name: 'Name', type: 'STRING', is_required: true },
    { name: 'Designation', type: 'STRING', is_required: true },
    { name: 'Department', type: 'STRING', is_required: true },
    { name: 'Mobile Number', type: 'STRING', is_required: true },
    { name: 'Email', type: 'STRING', is_required: true },
    { name: 'MPOC', type: 'STRING', is_required: true },
    { name: 'Landline Number', type: 'STRING', is_required: true },
    { name: 'STD Code', type: 'STRING', is_required: true },
    { name: 'Decision Maker', type: 'STRING', is_required: true },
    { name: 'Comments', type: 'STRING', is_required: true },
  ],
  location_details: [
    { name: 'Address', type: 'STRING', is_required: true },
    { name: 'Landmark', type: 'STRING', is_required: true },
    { name: 'Area', type: 'DROPDOWN', is_required: true, options: [] },
    { name: 'Sub Area', type: 'DROPDOWN', is_required: true, options: [] },
    { name: 'City', type: 'DROPDOWN', is_required: true, options: [] },
    { name: 'State', type: 'DROPDOWN', is_required: true, options: [] },
    { name: 'Pincode', type: 'STRING', is_required: true },
    { name: 'Latitude', type: 'STRING', is_required: true },
    { name: 'Longitude', type: 'STRING', is_required: true },
  ],
  society_details: [
    { name: 'FlatCount', type: 'FLOAT', is_required: true },
    { name: 'TowerCount', type: 'FLOAT', is_required: true },
    {
      name: 'QualityType',
      type: 'DROPDOWN',
      is_required: true,
      options: ['Standard', 'Medium High', 'High', 'Ultra High'],
    },
    { name: 'AverageHouseholdOccupant', type: 'FLOAT', is_required: true },
    { name: 'BachelorTenantsAllowed', type: 'DROPDOWN', is_required: true, options: ['Yes', 'No'] },
  ]
};

export default additional_attributes_dict;